import { Button, Spinner, Tooltip } from '@heroui/react'
import { Download, Play, Square } from 'lucide-react'
import { useTestScript } from './utils'

export default function ReadScriptButton({ expressiveness, consistency }) {
  const {
    playScript,
    pauseScript,
    downloadScript,
    isGenerating,
    isDownloading,
    isPlaying,
  } = useTestScript(expressiveness, consistency)

  return (
    <>
      <Tooltip
        placement="left"
        content={(
          <span className="flex flex-col items-start">
            <p className="text-sm">TTS generation is billed at:</p>
            <p className="text-sm">
              <b>Enterprise:</b>
              {' '}
              $0.02/400 characters
            </p>
            <p className="text-sm">
              <b>Scale:</b>
              {' '}
              $0.02/200 characters
            </p>
            <p className="text-sm">
              <b>Build:</b>
              {' '}
              $0.02/150 characters
            </p>
            <p className="text-sm">
              <b>Start:</b>
              {' '}
              $0.02/100 characters
            </p>
          </span>
        )}
      >
        <Button
          radius="none"
          color="primary"
          variant="flat"
          size="sm"
          onPress={isPlaying ? pauseScript : playScript}
          className="shrink-0"
          disableRipple
          spinner={<Spinner size="sm" variant="spinner" classNames={{ spinnerBars: 'bg-white' }} />}
          isLoading={isGenerating && !isPlaying}
        >
          {isPlaying
            ? (
                <>
                  <Square size={16} fill="currentColor" />
                  Stop
                </>
              )
            : isGenerating
              ? 'Generating...'
              : (
                  <>
                    <Play size={16} />
                    Test Script
                  </>
                )}
        </Button>
      </Tooltip>

      <Tooltip content="Download sample generation">
        <Button
          radius="none"
          isIconOnly
          color="primary"
          variant="light"
          size="sm"
          onPress={downloadScript}
          className="shrink-0"
          disableRipple
          isLoading={isDownloading}
        >
          <Download size={16} />
        </Button>
      </Tooltip>
    </>
  )
}
